
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iOsEl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $78789dd194b50e02$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $78789dd194b50e02$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': "\u3059\u3079\u3066\u306E\u30B5\u30A4\u30C8",
    'navigation.global-shortcuts.apps.align': 'Align',
    'navigation.global-shortcuts.apps.analytics': "\u30A2\u30CA\u30EA\u30C6\u30A3\u30AF\u30B9",
    'navigation.global-shortcuts.apps.assets': "\u30A2\u30BB\u30C3\u30C8",
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': "\u4F1A\u793E\u30CF\u30D6",
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': "\u30B4\u30FC\u30EB",
    'navigation.global-shortcuts.apps.home': "\u30DB\u30FC\u30E0",
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8",
    'navigation.global-shortcuts.apps.studio': "\u30B9\u30BF\u30B8\u30AA",
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': "\u30C1\u30FC\u30E0",
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "\u9589\u3058\u308B",
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': "{name} \u30B5\u30A4\u30C8",
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(\u73FE\u5728\u5229\u7528\u3067\u304D\u307E\u305B\u3093)",
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': "\u5916\u90E8\u30EA\u30F3\u30AF\u3092\u958B\u304F\u30A2\u30A4\u30B3\u30F3",
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': "(\u8AAD\u307F\u8FBC\u307F\u4E2D)",
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': "(\u8AAD\u307F\u8FBC\u307F\u4E2D)",
    'navigation.global-shortcuts.shortcut-action.open-menu-label': "\u30E1\u30CB\u30E5\u30FC\u3092\u958B\u304F",
    'navigation.global-shortcuts.sites': "{productName} \u4EF6\u306E\u30B5\u30A4\u30C8"
};

});


//# sourceMappingURL=ja.931d265a.js.map
